import { render, staticRenderFns } from "./FacilityManagementStaffEdit.vue?vue&type=template&id=6504c40c"
import script from "./FacilityManagementStaffEdit.vue?vue&type=script&lang=ts"
export * from "./FacilityManagementStaffEdit.vue?vue&type=script&lang=ts"
import style0 from "./FacilityManagementStaffEdit.vue?vue&type=style&index=0&id=6504c40c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports